import { QueryClient, QueryClientConfig } from '@tanstack/react-query';

export const queryOptions: QueryClientConfig = {
  defaultOptions: {
    mutations: {
      networkMode: 'offlineFirst',
    },
    queries: {
      networkMode: 'offlineFirst',
    },
  },
};

// eslint-disable-next-line no-underscore-dangle
let _queryClient: QueryClient;

/**
 * Gets existing QueryClient instance or create a new one
 * @returns {QueryClient}
 */
export function getQueryClient(): QueryClient {
  if (!_queryClient) {
    const client: QueryClient = new QueryClient(queryOptions);

    _queryClient = Object.assign(client);
  }

  return _queryClient;
}
